// extracted by mini-css-extract-plugin
export default {"textarea":"MetatagsSection_textarea__OIK9Q","textareaContainer":"MetatagsSection_textareaContainer__6N7Wo"};